const thirdpartyTracker = () => {
    console.log('thirdpartyTracker');
}

export default thirdpartyTracker;